module.exports = __webpack_public_path__ + "media/images/badge-trotter-6b18e0cf04f7a49d272a6fb49f6e7670.png";